import { Link } from "react-router";
import { HexToFilter } from "../Tools/HexToFilter";

export function NavButton({ text, link, trailingIcon, iconColor, className = 'navButton', reload = false }) {
  return (
    <>
      <Link
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px', fontFamily: 'Jura', fontWeight: 'normal' }}
        draggable={false}
        reloadDocument={reload}
        to={link}
        className={className}>
        {text}{' '}
        {trailingIcon && (
          <img alt='' style={{ filter: `${HexToFilter.CreateFilter(iconColor ?? '#ffffff')}` }} src={trailingIcon} height={14} width={14} />
        )}
      </Link>
    </>
  );
}
